import React from 'react';
import { fishingClubData } from '../data/fishingClubData';
import { Timeline } from "./ui/timeline";
import PageWrapper from "../components/PageWrapper";
import { FaFilePdf } from "react-icons/fa";

export function TimelineVerein() {
  const data = fishingClubData.map(item => ({
    title: item.title,
    content: (
      <div>
        <div
          className="font-body text-base sm:text-lg text-gray-700 py-1 rounded px-6 sm:px-6 lg:px-4 space-y-3"
          dangerouslySetInnerHTML={{ __html: item.content }}
        />

        {item.image && (
          <img
            src={item.image}
            alt={`Bild zu ${item.title}`}
            className="my-3 rounded-lg shadow-md"
          />
        )}

        {item.attachment && (
          <a
            href={item.attachment.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${item.attachment.title} als PDF herunterladen`}
            title={item.attachment.title}
            className="inline-flex items-center gap-x-2 py-2 px-4 bg-sky-600 hover:bg-sky-700 text-sm text-white rounded-full focus:outline-none focus:ring-2 focus:ring-sky-700 group font-body transition mt-2"
          >
            <FaFilePdf
              className="transition-transform transform group-hover:rotate-4 group-hover:scale-110"
              aria-hidden="true"
            />
            {item.attachment.title} (PDF)
          </a>
        )}
      </div>
    ),
  }));

  return (
    <PageWrapper>
      <div
        className="py-12 sm:py-16 min-h-screen px-6"
        style={{
          backgroundImage: `url('/bg2.svg'), linear-gradient(to bottom, #e0f2fe, #ffffff)`,
          backgroundRepeat: "no-repeat, no-repeat",
          backgroundSize: "cover, cover",
          backgroundPosition: "center, center",
        }}
      >
        <Timeline data={data} />
      </div>
    </PageWrapper>
  );
}
